module.exports = __webpack_public_path__ + "img/save.d75bb86f.png";